/*
API requests related to assets
*/
import { apiRequest, downloadFile } from '../../plugins/core/dd.data.connect.js'


export const downloadAssetPosition = (data, opt = {}) =>{

  var p = new Promise((resolve, reject) => {

    const type = opt.fileType

    downloadFile(`/assets/${data.id}/positions/${data.from}/${data.till}/download?fileType=${type}`, opt, opt).then((res) => {
        // let blob = new Blob([response.data], { type: 'application/jpeg' } ),
        // url = window.URL.createObjectURL(blob)
        // window.open(url);
        resolve()
        //
        }).catch((e) => {
          reject(e);
        })

    // directOpen(`/order-documents/${data.id}`).then((res) => {
    //     resolve(res)
    //   }).catch((e) => {
    //     reject(e);
    //   })

  }).catch((e) => {
    console.error(e)
  })
  return p;
}

// ASSET-GROUPS  ===========================================================================================================
export const allGroups = (params) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET',`/asset-groups`, null, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const singleGroup = (data,params) => {
  var p = new Promise((resolve, reject) => {
    if(!data.groupId)
      reject("groupId is mandatory")

    apiRequest('GET',`/asset-groups/${data.groupId}`, null, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const allAssetGroupCustomFields = (data, params) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET',`/asset-groups/${data.id}/custom-fields`, null, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const allTypes = (params) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET', `/asset-types`, null, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const unitTypeStatusesByDataFields = (data, params) => {
  var p = new Promise((resolve, reject) => {
    
    if(!data.unit_type_id){
      reject({'data':'no unit_type_id given'})
    }    
    apiRequest('GET', `/unit-types/${data.unit_type_id}/statuses-by-data-fields`, null, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const allUnitTypeDataFields = (data, params) => {
  var p = new Promise((resolve, reject) => {
    
    if(!data.unit_type_id){
      reject({'data':'no unit_type_id given'})
    }    
    apiRequest('GET', `/unit-types/${data.unit_type_id}/data-fields`, null, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const oneAsset = (data, params) => {
  var p = new Promise((resolve, reject) => {
    if(!data.id)
      reject({'data': 'no id given'});
    apiRequest('GET',`/assets/${data.id}`,null, params ).then((res) => {
      resolve(res.data.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const allAssetDossierItems =  (data, params) => {
  var p = new Promise((resolve, reject) => {
    if(!data.assetId)
      reject({'data': 'no id given'});

    apiRequest('GET',`/assets/${data.assetId}/dossier-items`,null, params ).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}



export const deleteAssetGeoZoneEvent = (data, params) => {
  
  var p = new Promise((resolve, reject) => {    
      if(!data.assetGeoZoneEventId)
        reject({'data': 'no asset id given'});
      apiRequest('DELETE',`/asset-geo-zone-events/${data.assetGeoZoneEventId}`,null, params ).then((res) => {
    resolve(res.data.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const saveAssetGeoZoneEvent = (data) => {
  
  var p = new Promise((resolve, reject) => {    
    let method = "POST"
    let id     = ""

    if(data.id){
       method = "PUT"
       id     = "/"+data.id
    }
    else{ // mandatory if assetGeoZoneEventId is not given
        if(!data.assetId)
          reject({'data': 'no asset id given'});
        if(!data.geoZoneEventId)
          reject({'data': 'no geo zone event id given'});  
    }

    apiRequest(method,`/asset-geo-zone-events${id}`,data, {} ).then((res) => {
      resolve(res.data.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}


export const deleteAssetGroupGeoZoneEvent = (data, params) => {
  
  var p = new Promise((resolve, reject) => {    
      if(!data.assetGroupGeoZoneEventId){
        reject({'data': 'no asset id given'})
      }
      apiRequest('DELETE',`/asset-group-geo-zone-events/${data.assetGroupGeoZoneEventId}`,null, params ).then((res) => {
          resolve()
      }).catch((e) => {
        reject(e)
      })
  })
  return p
}

export const saveAssetGroupGeoZoneEvent = (data) => {
  
  var p = new Promise((resolve, reject) => {    
    let method = "POST"
    let id     = ""

    if(data.id){
       method = "PUT"
       id     = "/"+data.id
    }
    else{ // mandatory if assetGeoZoneEventId is not given
        if(!data.assetGroupId)
          reject({'data': 'no asset id given'});
        if(!data.geoZoneEventId)
          reject({'data': 'no geo zone event id given'});  
    }

    apiRequest(method,`/asset-group-geo-zone-events${id}`,data, {} ).then((res) => {
      resolve(res.data.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}


export const deleteAssetImage = (data, params) => {
  
  var p = new Promise((resolve, reject) => {    
    
    apiRequest('DELETE',`/assets/${data.assetId}/images/${data.imageId}`,null, params ).then((res) => {
    resolve(res.data.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const allUnitTypes = (params) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET', `/unit-types`, null, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const allAssets = (data, params) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET',`/assets`,null, params ).then((res) => {
      resolve(res.data.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const searchAssets = (data, params) => {
  var p = new Promise((resolve, reject) => {
    if(data.searchTerm && data.searchTerm.length > 0){
      apiRequest('GET',`/assets/search/${data.searchTerm}`,null, params ).then((res) => {
        if(res.data){
          resolve(res.data)
        }else{
          resolve()
        }
      
      }).catch((e) => {
        reject(e)
      })
    }
    else{
      apiRequest('GET',`/assets`,null, params ).then((res) => {
        if(res.data){
          resolve(res.data)
        }else{
          resolve()
        }
      
      }).catch((e) => {
        reject(e)
      })
    }
  })
  return p
}

export const assetRoutes = (data, params) => {
  var p = new Promise((resolve, reject) => {
    if(!data.id)
      reject({'data': 'no id given'});
    apiRequest('GET',`/assets/${data.id}/routes/${data.from}/${data.till}`,null, params ).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const assetProcessedEvents = (data, params) => {
  var p = new Promise((resolve, reject) => {
    if(!data.id)
      reject({'data': 'no id given'});
    apiRequest('GET',`/assets/${data.id}/processed-events`,null, params ).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const assetProcessedActions = (data, params) => {
  var p = new Promise((resolve, reject) => {
    if(!data.id)
      reject({'data': 'no id given'});
    apiRequest('GET',`/assets/${data.id}/actions`,null, params ).then((res) => {
      resolve(res.data.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const assetTimeSerie = (data, params) => {
  var p = new Promise((resolve, reject) => {
    if(!data.assetId)
      reject({'data': 'no assetId given'});
    if(!data.timeSerieId)
        reject({'data': 'no timeSerieId given'});

    apiRequest('GET',`/assets/${data.assetId}/time-series/${data.timeSerieId}`,null, params ).then((res) => {
      resolve(res.data.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const oneGroup = (params) => {
  var p = new Promise((resolve, reject) => {

    if(!params.id)
      reject({'data': 'no id given'});

    apiRequest('GET',`/asset-groups/${params.id}`, {...params}).then((res) => {
      resolve(res.data.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const saveUnitTypeTimeSerie = (data) => {
  var p = new Promise((resolve, reject) => {
    let method
    let url
    
    if(data.id){
      url =  `/unit-type-time-series/${data.id}`
      method = 'PUT'
    }
    else{
      url =  `/unit-type-time-series`
      method = 'POST'
    }
    apiRequest(method, url, data).then((res) => {
         resolve(res.data.data)
       }).catch((e) => {
         reject(e);
       })
     })     
   return p;
}

export const saveAsset = (data,params) => {
  var p = new Promise((resolve, reject) => {
    let method
    let url
    
    if(data.id){
      url =  `/assets/${data.id}`
      method = 'PUT'
    }
    else{
      url =  `/assets`
      method = 'POST'
    }
    apiRequest(method, url, data).then((res) => {
         resolve(res.data.data)
       }).catch((e) => {
         reject(e);
       })
     })     
   return p;
}

export const saveAssetCustomFields = (data,params) => {
  var p = new Promise((resolve, reject) => {
    let method = 'PUT'
    let url =  `/assets/${data.assetId}/custom-fields`

    apiRequest(method, url, data.fields).then((res) => {
         resolve(res.data.data)
       }).catch((e) => {
         reject(e);
       })
     })     
   return p;
}

export const saveGroup = (data) => {
  var p = new Promise((resolve, reject) => {
    let method
    let url
    
    if(data.id){
      url =  `/asset-groups/${data.id}`
      method = 'PUT'
    }
    else{
      url =  `/asset-groups`
      method = 'POST'
    }
    apiRequest(method, url, data).then((res) => {
         resolve(res.data.data)
       }).catch((e) => {
         reject(e);
       })
     })     
   return p;
}

export const saveType = (data) => {
  var p = new Promise((resolve, reject) => {
    let method
    let url
    
    if(data.id){
      url =  `/asset-types/${data.id}`
      method = 'PUT'
    }
    else{
      url =  `/asset-types`
      method = 'POST'
    }

    apiRequest(method,url, data).then((res) => {
         resolve(res.data.data)
       }).catch((e) => {
         reject(e);
       })
     })
   return p;
}

export const deleteGroup = (params) => {
  var p = new Promise((resolve, reject) => {
    if(!params.id)
      reject({'data': 'no id given'});    

    apiRequest('DELETE',`/asset-groups/${params.id}`, params).then(() => {
         resolve()
       }).catch((e) => {
         reject(e);
       })
     })
   return p;
}

export const deleteType = (params) => {
  var p = new Promise((resolve, reject) => {
    if(!params.id)
      reject({'data': 'no id given'});    

    apiRequest('DELETE',`/asset-groups/${params.id}`, params).then(() => {
         resolve()
       }).catch((e) => {
         reject(e);
       })
     })
   return p;
}

export const assetUpdatedPositions = (timestamp, params) => {
  var p = new Promise((resolve, reject) => {
    
    apiRequest('GET',`/assets/updated-positions/${Math.round(timestamp)}?include=currentPosition,group&disablePaging=1`, params).then((data) => {
         resolve(data.data)
       }).catch((e) => {
         reject(e);
       })
     })
   return p;
}

export const assetExecuteAction = (data) => {
  var p = new Promise((resolve, reject) => {      
    apiRequest('POST', `/asset-actions/${data.id}/execute`, data).then((res) => {
         resolve(res.data.data)
       }).catch((e) => {
         reject(e);
       })
     })     
   return p;
}



export const discardProcessedEvent = (data, params) => {
  var p = new Promise((resolve, reject) => {
    let method
    let url
    
    
    apiRequest('POST', `/processed-events/${data.id}/discard`, data).then((res) => {
         resolve(res.data.data)
       }).catch((e) => {
         reject(e);
       })
     })     
   return p;
}

export const assetCancelAction = (data) => {
  var p = new Promise((resolve, reject) => {
    let method
    let url
    
    
    apiRequest('POST', `/asset-actions/${data.id}/cancel`, data).then((res) => {
         resolve(res.data.data)
       }).catch((e) => {
         reject(e);
       })
     })     
   return p;
}

export const allDataFieldTypes = (params) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET', `/data-field-types`, null, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const assetLocations = (data, params) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET', `/assets/${data.id}/positions/${data.from}/${data.till}`, null, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const saveDataField = (data) => {
  var p = new Promise((resolve, reject) => {
    let method
    let url
    
    if(data.id){
      url =  `/data-fields/${data.id}`
      method = 'PUT'
    }
    else{
      url =  `/data-fields`
      method = 'POST'
    }

    apiRequest(method,url, data).then((res) => {
         resolve(res.data.data)
       }).catch((e) => {
         reject(e);
       })
     })
   return p;
}
export const saveDataFieldStatus = (data) => {
  var p = new Promise((resolve, reject) => {
    let method
    let url
    
    if(data.id){
      url =  `/statuses-by-data-fields/${data.id}`
      method = 'PUT'
    }
    else{
      url =  `/statuses-by-data-fields`
      method = 'POST'
    }
    
    apiRequest(method,url, data).then((res) => {
         resolve(res.data.data)
       }).catch((e) => {
         reject(e);
       })
     })
   return p;
}


export const assetGeoZoneEvents = (data, params) => {
  var p = new Promise((resolve, reject) => {
    if(!data.assetId){
      reject("assetId is mandatory")        
    }
    apiRequest('GET',`/assets/${data.assetId}/asset-geo-zone-events`, data, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {      
      reject(e)
    })
  })
  return p
}

export const assetGeoZoneEventsSearch = (data, params) => {
  var p = new Promise((resolve, reject) => {
    if(!data.assetId){
      reject("assetId is mandatory")        
    }
    apiRequest('GET',`/assets/${data.assetId}/asset-geo-zone-events/search/${data.value}`, data, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {      
      reject(e)
    })
  })
  return p
}  

export const assetGroupGeoZoneEvents = (data, params) => {
  var p = new Promise((resolve, reject) => {

    let url    = ""
    
    if(!data.assetGroupId){
      reject("assetId is mandatory")        
    }

    if(data.unitTypeId){    
      url = `/asset-groups/${data.assetGroupId}/unit-types/${data.unitTypeId}/asset-group-geo-zone-events`
    }
    else{
      url = `/asset-groups/${data.assetGroupId}/asset-group-geo-zone-events`
    }

    apiRequest('GET',url, data, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {      
      reject(e)
    })
  })
  return p
}

// ASSETS  ===========================================================================================================
